import * as React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { RootState } from '../../store/types';
import MenuListItem from './MenuListItem';
import { getMenuAPI } from './state/actions';
import { SectionBar, MenuContainer, MenuItemChildren, SubMenu, SubMenuTitle } from './styles';
import {Menu, MenuUrl, MenuVisible} from './state/types';
import { ListingType, ListingUI } from 'features/Dealers/Listings/state/types';
import { create } from 'lodash';
import { UIDepartment } from 'features/Dealers/DealerConfiguration/Departments/state/types';
import { setShowHeader } from '../Dealers/AdvancedLm/state/actions';

export interface RootProps {
    menuItems: Menu[]
    selectedMenuOption?: Menu
    selectionCondition: string | null;

    handleSelectItem: (selected: MenuOption) => void;
    collapse?: boolean;
    hideSearch: (hide: boolean) => void;
}

const PlatformMenu = (props: any) => {
    const [selectedSections, setSelectedSections] = React.useState<Menu[]>([])
    const [showSubmenu, setShowSubmenu] = React.useState<boolean>(false);

    const dispatch = useDispatch();
    const location = useLocation()
    
    
    React.useEffect(() => {
        dispatch(getMenuAPI())
    }, [dispatch])

    const {
        menuItems
    } = useSelector((rootState: RootState) => {
        return {
            menuItems: rootState.menu.items?.filter(item => item.settingsPanel !== true)
        }
    }, shallowEqual);


    const {
        engineDealer,
        selectedDealer,
        connected,
        listingsByDealerId,
        syncErrors,
        liveDepartments,
        industry,
    } = useSelector((rootState: RootState) => {
        return {
            engineDealer: rootState.dealers.enginedealer.enginedealer,
            connected: rootState.dealers.connectByLabel.connect,
            selectedDealer: rootState.dealers.dealer.selectedDealer,
            listingsByDealerId: rootState.dealers.listing.listings.byDealerId,
            syncErrors: rootState.dealers.listing.listings.syncErrors,
            liveDepartments: (rootState.dealers.dealer.selectedDealer?.industry === "Automotive") ? rootState.dealers.departments.liveDepartments : undefined,
            industry: rootState.dealers.dealer.industry
        }
    }, shallowEqual)

    
    const departments = React.useMemo(() => {
        if (selectedDealer && listingsByDealerId[selectedDealer?.id]) {
            return listingsByDealerId[selectedDealer?.id].filter(o => o.type == ListingType.DEPARTMENT && o.id != null && o.idInSource != null)
        }
        return [];
    }, [listingsByDealerId])

    const validateMenuPackage = (packageAllow?: string) => {
        if(!packageAllow) return true;
        return  selectedDealer?.lmPackage
                ? packageAllow.includes(selectedDealer?.lmPackage)
                : packageAllow.includes("BASIC")
    }

    const handleOver = (over: boolean) => setShowSubmenu(over);




    if (!menuItems) {
        return null
    }
    
    return (
        <MenuContainer>
            {
                menuItems.map((item: Menu) => {
                    const isSelected = isItemSelected(item)
                    const isconnected = isConnected()  
                    const show = item.internalName==='reviews' && !isconnected ? false : true;      
                    if (item.url?.length>0 && validateMenuPackage(item.package) && show) 
                        return (
                        <>
                        <MenuListItem
                            key={`${item.internalName}`}
                            isSelected={isSelected}
                            menuItem={item}
                            handleSelectItem={handleSelectItem}
                            hasChildren={item.children.length !== 0}
                            status={isconnected?"CONNECTED":"DISCONNECTED"}
                            hasError={listingPrimaryHasError(item.internalName)}
                            collapse={props.collapse}
                            onOver={(over: boolean) => handleOver(over)}
                        />

                        {(showSubmenu && item.internalName.toLowerCase() == "edit" && departments?.length>0 ) && 
                        <SubMenu collapse={props.collapse} onMouseLeave={() => setShowSubmenu(false)}>
                            <SubMenuTitle>Departments</SubMenuTitle>
                            { item.internalName.toLowerCase() == "edit"  && departments.map((dep: ListingUI)=>{
                            //item.internalName.toLowerCase() == "edit"  && liveDepartments && liveDepartments.map((dep: UIDepartment)=>{
                              
                                const menudep = createMenuFromListing(dep);
                                const isSelected = isItemSelected(menudep);
                                return (
                                    <MenuItemChildren>
                                        <MenuListItem
                                            key={`${dep.deparmentId}`}
                                            isSelected={isSelected}
                                            menuItem={menudep}
                                            handleSelectItem={handleSelectItem}
                                            status={isconnected?"CONNECTED":"DISCONNECTED"}
                                            hasError={listingHasError(dep)}
                                            isChildren={true}
                                        />
                                    </MenuItemChildren>
                                )         
                            }) }
                        </SubMenu>}
                        </>
                    )
                    
                    
                    
                })
            }
        </MenuContainer>
    );

    function listingPrimaryHasError(internalName: string)
    {
        if (internalName=='primary' && selectedDealer && listingsByDealerId[selectedDealer?.id]) {
            const listingPrimary=listingsByDealerId[selectedDealer?.id].filter(o => o.type == ListingType.PRIMARY && o.id != null && o.idInSource != null);
            if(listingPrimary && listingPrimary.length>0)
            {
                const typedListingPrimary : ListingUI = listingPrimary[0];
                return  listingHasError(typedListingPrimary);
            }
        }
        return false;
    }

    function listingHasError(listing: ListingUI)
    {
        if(syncErrors?.find(error => error.listingId == listing.id && error.hasErrors))
        {
            return true;
        }
        return false;
    }

    function createMenuFromListing(listing: ListingUI)
    {
        let menuurldep : MenuUrl = 
        {
            path:"/dealer/department/"+listing.deparmentId,
            status:"CONNECTED",
            role:"string"
        }
        let arraymenuurl: MenuUrl[]=[];
        arraymenuurl.push(menuurldep);

        let menuvisibledep : MenuVisible ={
            status : "CONNECTED",
            value: true
        }

        let arrayvisible: MenuVisible[] = []
        arrayvisible.push(menuvisibledep);
        
        let menudep: Menu = {
            internalName: listing.deparmentId?listing.deparmentId:"",
            displayName: listing.deparmentId?listing.deparmentId:"",
            url: arraymenuurl,
            visible: arrayvisible,
            children:[]
        }

        return menudep;
    }

    function createMenuFromDepartment(dep: UIDepartment)
    {
        let menuurldep : MenuUrl = 
        {
            path:"/dealer/department/"+dep.name,
            status:"CONNECTED",
            role:"string"
        }
        let arraymenuurl: MenuUrl[]=[];
        arraymenuurl.push(menuurldep);

        let menuvisibledep : MenuVisible ={
            status : "CONNECTED",
            value: true
        }

        let arrayvisible: MenuVisible[] = []
        arrayvisible.push(menuvisibledep);
        
        let menudep: Menu = {
            internalName: dep.name,
            displayName: dep.name,
            url: arraymenuurl,
            visible: arrayvisible,
            children:[]
        }

        return menudep;
    }

    function handleSelectItem(item: Menu) {
        if(item.children.length > 0){
            let selected: Menu[] = selectedSections;
            if (selectedSections.filter(e => e === item).length === 0)
                selected.push(item)
            else 
                selected = selectedSections.filter(e => e !== item)
            setSelectedSections(selected)
            
        }
        setShowSubmenu(false);
        props.hideSearch(item.internalName==="advanced");
        dispatch(setShowHeader(true));
    }

    function isItemSelected(item: Menu) {
                
        if(item.children.length > 0)
            return selectedSections.filter(e => e === item).length > 0
        
        return location.pathname.endsWith("/"+item.internalName);
        
    }



    function isConnected() {
        if (connected?.connected)
            return true;
        if (engineDealer)
            return engineDealer?.statusConected == "ACTIVE";

        
        return false;
    }
}

export default PlatformMenu;
